import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { FlattenSimpleInterpolation as _FlattenSimpleInterpolation } from "styled-components";
import _styled from "styled-components";
var _excluded = ["touch"];
import { useHover } from "@react-aria/interactions";
import { useCallback, useMemo, useRef, useState } from "react";
export function useTouchArea(_ref) {
  var touch = _ref.touch,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  var onPress = useCallback(function () {
    var _ref$current, _ref$current2;

    switch (touch) {
      case "click":
        (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.click();
        break;

      case "focus":
        (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.focus();
        break;

      default:
        {
          var _exhaustiveCheck = touch;
        }
    }
  }, [touch]);

  var _useHover = useHover({
    isDisabled: props.disabled
  }),
      hoverProps = _useHover.hoverProps,
      isHovered = _useHover.isHovered;

  var _useTouchAreaPress = useTouchAreaPress({
    onPress: onPress,
    disabled: props.disabled
  }),
      pressProps = _useTouchAreaPress.pressProps,
      isPressed = _useTouchAreaPress.isPressed;

  return {
    TouchArea: TouchArea,
    touchAreaProps: _objectSpread(_objectSpread(_objectSpread({}, props), hoverProps), pressProps),
    targetRef: ref,
    isHovered: isHovered,
    isPressed: isPressed
  };
}

var useTouchAreaPress = function useTouchAreaPress(_ref2) {
  var onPress = _ref2.onPress,
      disabled = _ref2.disabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPressed = _useState2[0],
      setIsPressed = _useState2[1];

  var pressProps = useMemo(function () {
    if (disabled) return {};
    var touchEvents = {
      onTouchStart: function onTouchStart() {
        setIsPressed(true);
      },
      onTouchCancel: function onTouchCancel() {
        setIsPressed(false);
      },
      onTouchEnd: function onTouchEnd(e) {
        e.preventDefault(); // Cancel mouse events

        if (isPressed) {
          onPress();
          setIsPressed(false);
        }
      }
    };
    var mouseEvents = {
      onMouseDown: function onMouseDown() {
        setIsPressed(true);
      },
      onMouseUp: function onMouseUp() {
        if (isPressed) {
          onPress();
          setIsPressed(false);
        }
      }
    };
    return _objectSpread(_objectSpread({}, touchEvents), mouseEvents);
  }, [isPressed, disabled, onPress]);
  return {
    pressProps: pressProps,
    isPressed: isPressed
  };
};

var TouchArea = _styled.div.withConfig({
  displayName: "useTouchArea__TouchArea",
  componentId: "sc-101jzj6-0"
})(["cursor:", ";display:", ";padding:", ";", ""], function (p) {
  var _p$cursor;

  return p.disabled ? "initial" : (_p$cursor = p.cursor) !== null && _p$cursor !== void 0 ? _p$cursor : "pointer";
}, function (p) {
  var _p$display;

  return (_p$display = p.display) !== null && _p$display !== void 0 ? _p$display : "inline-block";
}, function (p) {
  var _p$paddingVertical, _p$paddingHorizontal;

  return "".concat((_p$paddingVertical = p.paddingVertical) !== null && _p$paddingVertical !== void 0 ? _p$paddingVertical : 6, "px ").concat((_p$paddingHorizontal = p.paddingHorizontal) !== null && _p$paddingHorizontal !== void 0 ? _p$paddingHorizontal : 6, "px");
}, function (p) {
  return p.customCss;
});
//# sourceMappingURL=useTouchArea.js.map